
import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Svg, Path } from 'react-native-svg';
import { useLanguage } from '../contexts/LanguageContext';

interface PeriodFilterContentProps {
  selectedPeriod: 'all' | '7days' | '15days' | '30days';
  onPeriodChange: (period: 'all' | '7days' | '15days' | '30days') => void;
}

export default function PeriodFilterContent({ selectedPeriod, onPeriodChange }: PeriodFilterContentProps) {
  const { t } = useLanguage();
  
  const periodOptions = [
    { id: '7days' as const, label: t('filters.period.last7days') },
    { id: '15days' as const, label: t('filters.period.last15days') },
    { id: '30days' as const, label: t('filters.period.last30days') },
  ];

  const handleOptionPress = (periodId: 'all' | '7days' | '15days' | '30days') => {
    onPeriodChange(periodId);
  };

  return (
    <View style={styles.container}>
      {periodOptions.map((option) => (
        <TouchableOpacity
          key={option.id}
          style={[
            styles.optionCard,
            selectedPeriod === option.id && styles.selectedOptionCard
          ]}
          onPress={() => handleOptionPress(option.id)}
        >
          <Text style={styles.optionText}>{option.label}</Text>
          <View style={[
            styles.checkbox,
            selectedPeriod === option.id && styles.selectedCheckbox
          ]}>
            {selectedPeriod === option.id && (
              <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <Path 
                  d="M12.6654 4.7915L6.2487 11.2082L3.33203 8.2915" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                />
              </Svg>
            )}
          </View>
        </TouchableOpacity>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: 8,
  },
  optionCard: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 20,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#F0EEE4',
    backgroundColor: '#F9F8F3',
    gap: 4,
  },
  selectedOptionCard: {
    borderColor: '#004165',
    backgroundColor: '#E6EBF0',
  },
  optionText: {
    flex: 1,
    fontSize: 14,
    fontFamily: 'Inter_400Regular',
    color: '#151515',
    lineHeight: 19.6,
  },
  checkbox: {
    width: 24,
    height: 24,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#7E7D75',
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
  },
  selectedCheckbox: {
    borderWidth: 3,
    borderColor: '#015480',
    backgroundColor: '#015480',
    padding: 4,
  },
});
